import React, { useEffect, useState } from "react";
import { SITE_CONFIG, buildWhatsAppUrl } from "../config/site";

const WhatsAppIcon = ({ className = "w-7 h-7" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.486 2 2 6.486 2 12c0 1.98.586 3.823 1.594 5.37L2 22l4.63-1.594A9.928 9.928 0 0012 22c5.514 0 10-4.486 10-10S17.514 2 12 2zM8.954 8.527c-.138-.015-.275-.015-.412-.015-.152 0-.352.05-.53.27C7.824 9.001 7.2 9.61 7.2 10.68c0 1.07.72 2.056.824 2.194.105.138 1.512 2.433 3.708 3.27.42.164.765.263 1.05.343.375.104.71.09 1.006.045.328-.045 1.01-.412 1.154-.81.144-.396.144-.736.1-.81-.044-.073-.16-.12-.33-.21-.17-.09-1.01-.5-1.168-.56-.159-.06-.276-.09-.392.09-.117.18-.442.56-.542.675-.1.117-.197.132-.366.045-.17-.087-.71-.26-1.353-.835-.502-.45-.835-1.01-.962-1.185-.128-.176-.013-.27.077-.365.08-.08.17-.196.255-.294.085-.098.113-.167.17-.282.056-.115.028-.21-.014-.29-.042-.08-.392-1.01-.536-1.385-.144-.375-.29-.32-.4-.32h-.14z"
    />
  </svg>
);

const WhatsAppButton = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return (
    <a
      href={buildWhatsAppUrl(
        SITE_CONFIG.whatsapp.phone,
        SITE_CONFIG.whatsapp.defaultMessage
      )}
      target="_blank"
      rel="noreferrer"
      className="fixed right-6 bottom-6 z-40"
      aria-label="Chat on WhatsApp"
    >
      <div className="relative group">
        <button
          type="button"
          className="bg-[#79d752] text-black rounded-full p-3 shadow-lg hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500 transition-all transform hover:scale-110"
          aria-label="Open WhatsApp chat"
        >
          <WhatsAppIcon />
        </button>
        <div className="absolute -top-14 right-1/2 translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap px-3 py-2 bg-gray-900 text-white text-sm rounded-md shadow-lg">
          {SITE_CONFIG.whatsapp.tooltip}
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-3 h-3 bg-gray-900 rotate-45" />
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
